import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { opportunityDetailActions } from '../../../redux/opportunity/opportunity/opportunityDetailState';
import DataTable from '../../../components/templates/dataTable/DataTable';

const DEFAULT_SEARCH_CONDITION = {
  estimateId: '',
  order: 'asc',
  orderBy: 'display_order',
};

const headCells = [
  { id: 'planName', label: '商品名', sortId: 'plan_name' },
  {
    id: 'unitPrice', label: '税込単価', sortId: 'unit_price', numeric: true,
  },
  { id: 'quantity', label: '個数', sortId: 'quantity' },
  { id: 'taxRate', label: '税率', sortId: 'tax_rate' },
  {
    id: 'totalPrice', label: '合計金額', sortId: 'total_price', numeric: true,
  },
];

export default function EstimateList(props) {
  const { id } = props;
  const dispatch = useDispatch();
  const [datas, setDatas] = useState([]);
  const [searchCondition, setSearchCondition] = useState(DEFAULT_SEARCH_CONDITION);
  const estimateDatas = useSelector((state) => state.opportunityDetailStore.estimates);

  React.useEffect(() => {
    if (estimateDatas) {
      setDatas(estimateDatas);
    }
  }, [estimateDatas]);

  const search = (tempCondition) => {
    dispatch(opportunityDetailActions.getEstimateDetails(tempCondition));
  };

  React.useEffect(() => {
    if (id) {
      const tempSearchCondition = { ...DEFAULT_SEARCH_CONDITION, id };
      setSearchCondition(tempSearchCondition);
      search(tempSearchCondition);
    }
  }, [id]);

  const handleRequestSort = (_, property) => {
    const { order, orderBy } = property;
    const tempCondition = {
      ...searchCondition,
      orderBy,
      order,
    };
    setSearchCondition(tempCondition);
    search(tempCondition);
  };

  return (
    <DataTable
      rows={datas}
      headCells={headCells}
      procName="見積明細"
      handleRequestSort={handleRequestSort}
      order={searchCondition.order}
      orderBy={searchCondition.orderBy}
      isNoPagination
    />
  );
}
